/* eslint-disable react/no-danger */
// eslint-disable-next-line react/no-danger
import React from 'react';
import IconSmile from '@/assets/IconSmile.svg';

import { THeaderProps } from './types';

export const Header = React.memo(({ data: { header } }: THeaderProps) => {
  return (
    <>
      {header?.has_icon === 'true' ? (
        <div className="vitrine-template1__header">
          <span
            className="vitrine-template1__header--title1"
            data-testid="prefix"
          >
            {header.prefix}
          </span>
          {header.has_icon === 'true' && (
            <span className="vitrine-template1__header-icon" data-testid="icon">
              <img src={IconSmile} alt="Smile" />
            </span>
          )}
          <span className="vitrine-template1__header--title2">
            <strong data-testid="suffix">{header.suffix}</strong>
          </span>
        </div>
      ) : null}
    </>
  );
});
